import { render, staticRenderFns } from "./LandingPageButton.vue?vue&type=template&id=161cc8e0&scoped=true&"
import script from "./LandingPageButton.vue?vue&type=script&lang=ts&"
export * from "./LandingPageButton.vue?vue&type=script&lang=ts&"
import style0 from "./LandingPageButton.vue?vue&type=style&index=0&id=161cc8e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161cc8e0",
  null
  
)

export default component.exports